import {
  ContentContainer,
  FooterContainer,
  MainContainer,
  SidebarContainer,
  StateBarContainer,
  ToolbarContainer,
  TopBarContainer,
} from './components/layout/Containers';

import { SidebarContent } from './components/views/SidebarContent';
import { TopbarContent } from './components/views/TopbarContent';

import { Flip, ToastContainer } from 'react-toastify';
import { Scene } from './components/views/Scene';
import { StatebarButtonsTooltips } from './components/views/statebar/StatebarButtonsTooltips';
import { ToolbarTooltips } from './components/views/toolbarButtons/ToolbarButtonsTooltips';
import { TopbarButtonsTooltips } from './components/views/topbarButtons/TopbarButtonsTooltips';
import { useEditor } from './hooks/useEditor';

import 'react-toastify/dist/ReactToastify.css';
import { ResetViewButton } from './components/common/ResetViewButton';
import { FooterContent } from './components/views/FooterContent';
import { OnboardingModal } from './components/views/OnboardingModal';
import { ToolbarContent } from './components/views/ToolbarContent';
import { StatebarButtons } from './components/views/statebar/StatebarButtons';
import { Visibilitybar } from './components/views/visibilitybar/Visibilitybar';
import { Hooks } from './hooks';

function App() {
  const { UI } = useEditor();
  const { isToolbarExtended, isSidebarVisible, sceneIsDragging } = UI;

  return (
    <>
      <MainContainer $sceneIsDragging={sceneIsDragging}>
        <TopBarContainer className="editorContainer">
          <TopbarContent />
        </TopBarContainer>

        <ContentContainer id="contentContainer">
          <Scene />

          <ToolbarContainer
            $collapsed={!isToolbarExtended}
            className="editorContainer"
          >
            <ToolbarContent />
          </ToolbarContainer>

          <SidebarContainer
            $hidden={!isSidebarVisible}
            className="editorContainer"
          >
            <SidebarContent />
          </SidebarContainer>
          <StateBarContainer className="editorContainer">
            <Visibilitybar />
            <StatebarButtons />

            <ResetViewButton />
          </StateBarContainer>
        </ContentContainer>

        <FooterContainer className="editorContainer">
          <FooterContent />
        </FooterContainer>

        <div className="editorContainer">
          <TopbarButtonsTooltips />
          <StatebarButtonsTooltips />
          <ToolbarTooltips />
        </div>

        <OnboardingModal />

        <ToastContainer
          theme="dark"
          position="top-center"
          transition={Flip}
          className="editorContainer"
        />
      </MainContainer>

      <Hooks />
    </>
  );
}

export default App;
